module.exports = __webpack_public_path__ + "img/MEDIA087.3f7fddd4.jpg";